var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{scopedSlots:_vm._u([{key:"toolbar",fn:function(){return undefined},proxy:true},{key:"content",fn:function(){return [_c('AuthExtModal')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }